var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/envelope"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.75 5H3.75C3.55109 5 3.36032 5.07902 3.21967 5.21967C3.07902 5.36032 3 5.55109 3 5.75V18.5C3 18.8978 3.15804 19.2794 3.43934 19.5607C3.72064 19.842 4.10218 20 4.5 20H21C21.3978 20 21.7794 19.842 22.0607 19.5607C22.342 19.2794 22.5 18.8978 22.5 18.5V5.75C22.5 5.55109 22.421 5.36032 22.2803 5.21967C22.1397 5.07902 21.9489 5 21.75 5ZM12.75 12.9828L5.67844 6.5H19.8216L12.75 12.9828ZM10.0041 12.5L4.5 17.5447V7.45531L10.0041 12.5ZM11.1141 13.5172L12.2391 14.5531C12.3774 14.6801 12.5584 14.7506 12.7463 14.7506C12.9341 14.7506 13.1151 14.6801 13.2534 14.5531L14.3784 13.5172L19.8159 18.5H5.67844L11.1141 13.5172ZM15.4959 12.5L21 7.45438V17.5456L15.4959 12.5Z",
    fill: "#B9B9B9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.c3a27355f7db535b2ac3da1787b3471f.svg";
export { ForwardRef as ReactComponent };